import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { setUrl } from "../../../../../helper/utils";
import AmazonIcon from "../../../../../assets/images/common/Amazon_icon.png";
import ShopifyIcon from "../../../../../assets/images/common/shopify-icon.png";

const AmazonFriendly = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const [searchParams, setSearchParams] = useSearchParams();
  const [check, setCheck] = useState({
    amazon: false,
    shopify: false,
  });

  const handleAmazon = (e) => {
    setCheck({ ...check, amazon: e.target.checked });
  };

  const handleShopify = (e) => {
    setCheck({ ...check, shopify: e.target.checked });
  };

  useEffect(() => {
    navigate(
      setUrl(location.pathname, searchParams, "amazonFriendly", check.amazon)
    );
  }, [check.amazon]);

  useEffect(() => {
    navigate(
      setUrl(
        location.pathname,
        searchParams,
        "shopifyFriendly",
        check.shopify
      )
    );
  }, [check.shopify]);

  useEffect(() => {
    const amazonParam = searchParams.get("amazonFriendly");
    const shopifyParam = searchParams.get("shopifyFriendly");
    
    setCheck({
      amazon: amazonParam === 'true',
      shopify: shopifyParam === 'true',
    });
  }, [location]);

  return (
    <div className="product_filteration_section">
      <div className="amazon_friendly">
        <input
          type="checkbox"
          id="amazon"
          onChange={handleAmazon}
          checked={check.amazon || false}
        />
        <label htmlFor="amazon">
          <img src={AmazonIcon} alt="Amazon" /> <p>Friendly</p>
        </label>
      </div>

      <div className=" amazon_friendly shopify_friendly">
        <input
          type="checkbox"
          id="shopify"
          onChange={handleShopify}
          checked={check.shopify || false}
        />
        <label htmlFor="shopify">
          <img src={ShopifyIcon} alt="Shopify" /> <p>Friendly</p>
        </label>
      </div>
    </div>
  );
};

export default AmazonFriendly;
